var _defs, _defs2, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMWindowsCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 5000 2916",
    style: {
      enableBackground: "new 0 0 5000 2916"
    },
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#330066"
    },
    width: 5000,
    height: 2916
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "2800.321,2916 0,0 0,2916  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048471583028821237780000016687912172240956598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037669398377709203720000012314717379803972024_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.8637,
    y1: 129.0451,
    x2: 2868.2939,
    y2: 2979.5535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFF66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC33FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      clipPath: "url(#SVGID_00000048471583028821237780000016687912172240956598_)",
      fill: "url(#SVGID_00000037669398377709203720000012314717379803972024_)"
    },
    width: 2800.321,
    height: 2916
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1450.32,
    height: 2916
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1450.32,
    height: 2916,
    id: "SVGID_00000116957762016863048270000016569793469723315897_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155857430582096798480000013143979278216032920_",
    gradientUnits: "userSpaceOnUse",
    x1: -2878.6318,
    y1: 2183.7773,
    x2: -808.1616,
    y2: 113.3072,
    gradientTransform: "matrix(1 0 0 1 2878.0144 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "url(#SVGID_00000155857430582096798480000013143979278216032920_)"
    },
    width: 1450.32,
    height: 2916
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000116957762016863048270000016569793469723315897_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFF66"
    },
    points: " 0,2916 955.47,994.94 1450.32,0 0,0  "
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000153704102564262868750000016314131465836046769_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5000,
    height: 2916
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5000,
    height: 2916,
    id: "SVGID_00000106826598430599520500000016334100140166978198_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000153704102564262868750000016314131465836046769_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051355378808739451210000001192818904261570179_",
    gradientUnits: "userSpaceOnUse",
    x1: -2462.3918,
    y1: 3369.2671,
    x2: 547.9655,
    y2: 608.924,
    gradientTransform: "matrix(1 0 0 1 2878.0144 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "url(#SVGID_00000051355378808739451210000001192818904261570179_)"
    },
    width: 5000,
    height: 2916
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000106826598430599520500000016334100140166978198_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00CCFF"
    },
    points: " 1795.004,1869.155 5000,0 1450.32,0 955.47,994.94 0,2916  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMWindowsCardBg);
export default __webpack_public_path__ + "static/media/mWindowsCardBG.44edd4c3d1658426612279a623ab147c.svg";
export { ForwardRef as ReactComponent };